import type { AnalyticsEventType } from "@karat/shared";
import { api } from "../api/client";
import { getTelegramUserId } from "../telegram";

/** п.29 ТЗ: фіксація подій воронки. Fire-and-forget — аналітика не повинна блокувати UI. */
export function track(eventType: AnalyticsEventType, payload?: Record<string, unknown>): void {
  api
    .post("/api/analytics/event", { telegramUserId: getTelegramUserId(), eventType, payload })
    .catch(() => {
      /* аналітика не критична — тихо ігноруємо помилки мережі */
    });
}
